const { core } = window.o_util ?? {};
const {
  bind,
  clone,
  coerce,
  convertStringToFunction,
  deserialize,
  extend,
  isEmptyObject,
  isPlainObject,
  removeFromArray,
  serialize,
  serializeForm,
  toArray
} = core ?? {};
export {
  bind,
  clone,
  coerce,
  convertStringToFunction,
  core,
  deserialize,
  extend,
  isEmptyObject,
  isPlainObject,
  removeFromArray,
  serialize,
  serializeForm,
  toArray
};
/*                             */
